import httpClient from "Api/httpClient";

const END_POINT = "/subscription_plans";

const getSubscriptionPlans = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getSubscriptionPlan = (plan_id) => {
    if (!plan_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + plan_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printSubscriptionPlan = (plan_id) => {
    if (!plan_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?plan_id=" + plan_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createSubscriptionPlans = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateSubscriptionPlans = (payload, plan_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + plan_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteSubscriptionPlans = (plan_id) => {
    const DELETE_END_POINT = END_POINT + "/" + plan_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getSubscriptionPlans, getSubscriptionPlan, printSubscriptionPlan, createSubscriptionPlans, updateSubscriptionPlans, deleteSubscriptionPlans };
